import React from "react";
import { Link } from "@/i18n/router";
import { ArrowUpRight } from "lucide-react";

export function Overline({ children, className = "" }) {
  return (
    <span className={`text-xs font-bold uppercase tracking-[0.2em] text-astro-light ${className}`}>{children}</span>
  );
}

export function SectionHeading({ overline, title, sub, light = true, className = "", align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${alignCls} ${className}`}>
      {overline && <Overline>{overline}</Overline>}
      <h2 className={`mt-3 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
      {sub && <p className={`mt-5 text-lg leading-relaxed ${light ? "text-silver/70" : "text-slate-600"}`}>{sub}</p>}
    </div>
  );
}

export function PrimaryLink({ to, href, external, children, className = "", ...props }) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full bg-astro-blue px-7 py-3.5 font-semibold text-white hover:bg-astro-light transition-colors ${className}`;
  if (external || href)
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} {...props}>
        {children} <ArrowUpRight className="h-4 w-4" />
      </a>
    );
  return (
    <Link to={to} className={cls} {...props}>
      {children}
    </Link>
  );
}

export function GhostLink({ to, children, light = true, className = "", ...props }) {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full border-2 px-7 py-3.5 font-semibold transition-colors ${
    light ? "border-white/20 text-white hover:bg-white/10" : "border-astro-blue/30 text-astro-blue hover:bg-astro-blue/10"
  } ${className}`;
  return (
    <Link to={to} className={cls} {...props}>
      {children}
    </Link>
  );
}
